import axios from '@/libs/api.request'

export const page = (data) => {
  return axios.request({
    url: '/integral/page',
    method: 'get',
    params: data
  })
}

export const details = (data) => {
  return axios.request({
    url: `/integral/detailPage`,
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/integral.js